import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const softwareIncidentsClassicRoute: InvariantJiraRoute = {
	name: 'software-incidents-classic',
	path: '/jira/software/c/projects/:projectKey/incidents',
};
